export class ResetCompanyForm {
  static readonly type = '[CompanyForm] Reset';
}
